import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

// Protège les routes si pas d'accessToken
export const ProtectedRoute = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      navigate("/login");
      return;
    }
  }, [navigate]);

  return <Outlet />;
};
